import { DropdownItemModel, DynamicViewNavItem } from "Models";
import { NavConfigItem } from "Navigation";
import React from "react";
import { toggledClass, useSimpleDataFetcher } from "Utilities";
import { NavigationPillProps, NavPillDropdown } from ".";

export const DynamicNavigationPill: React.FC<NavigationPillProps> = ({
  route,
  active,
  navItemsUrl = "",
  ...otherProps
}) => {
  const [dynamicViewNavItems] = useSimpleDataFetcher(navItemsUrl, []);

  var navItems = dynamicViewNavItems as DropdownItemModel[];
  var dropdownItems = navItems?.map(
    (navItem) => new DynamicViewNavItem(navItem)
  ) as NavConfigItem[];

  if (dropdownItems.length === 0) {
    return null;
  }

  return (
    <div
      className={
        "navpill__wrapper flex-vertical-center" + toggledClass("active", active)
      }
    >
      <div className="navpill--underline" />
      <NavPillDropdown
        dropdownItems={dropdownItems}
        route={route}
        {...otherProps}
      />
    </div>
  );
};
